import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const CLOVER_PAYMENTS_CLOVER_PAYMENT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/clover-payments',
        iconClass: 'fas fa-file-alt',
        name: '::Menu:CloverPayments',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.CloverPayments',
      },
    ]);
  };
}
